import { NgModule } from "@angular/core";
import { AuthGuardService } from "./guards/auth-guard.service";
import { SupplierPortalV2GuardService } from "./guards/supplier-portal-v2-guard.service";
import { RouterModule, Routes } from "@angular/router";

export const appRoutes: Routes = [
  {
    path: "authkeys",
    loadChildren: () =>
      import("./authkeys/authkeys.module").then((m) => m.AuthKeysModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "configs",
    loadChildren: () =>
      import("./configs/configs.module").then((m) => m.ConfigsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "datapoints",
    loadChildren: () =>
      import("./datapoints/datapoints.module").then((m) => m.DatapointsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "datapointtargets",
    loadChildren: () =>
      import("./datapointtargets/datapointtargets.module").then(
        (m) => m.DatapointTargetsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "datapointtargetscripts",
    loadChildren: () =>
      import("./datapointtargetscripts/datapointtargetscripts.module").then(
        (m) => m.DatapointTargetScriptsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "datatypes",
    loadChildren: () =>
      import("./datatypes/datatypes.module").then((m) => m.DatatypesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "retentionpolicies",
    loadChildren: () =>
      import("./retentionpolicies/retentionpolicies.module").then(
        (m) => m.RetentionPoliciesModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "designer",
    loadChildren: () =>
      import("./designer/designer.module").then((m) => m.DesignerModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "images",
    loadChildren: () =>
      import("./images/images.module").then((m) => m.ImagesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "intervalexpressions",
    loadChildren: () =>
      import("./intervalexpressions/intervalexpressions.module").then(
        (m) => m.IntervalExpressionsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "macros",
    loadChildren: () =>
      import("./macros/macros.module").then((m) => m.MacrosModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "owners",
    loadChildren: () =>
      import("./owners/owners.module").then((m) => m.OwnersModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "survey",
    /*pathMatch: 'prefix',*/
    loadChildren: async () =>
      (await import("./preview/preview.module")).PreviewModule,
    canActivate: [AuthGuardService],
  },
  {
    path: "preview-bulk",
    /*pathMatch: 'prefix',*/
    loadChildren: () =>
      import("./preview/preview-bulk/preview-bulk.module").then(
        (m) => m.PreviewBulkModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "preview",
    /*pathMatch: 'prefix',*/
    loadChildren: () =>
      import("./preview/preview.module").then((m) => m.PreviewModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "regexes",
    loadChildren: () =>
      import("./regexes/regexes.module").then((m) => m.RegexesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "respondents",
    loadChildren: () =>
      import("./respondents/respondents.module").then(
        (m) => m.RespondentsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "scripts",
    loadChildren: () =>
      import("./scripts/scripts.module").then((m) => m.ScriptsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "tags",
    loadChildren: () => import("./tags/tags.module").then((m) => m.TagsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "objectgroups",
    loadChildren: () =>
      import("./objectgroups/objectgroups.module").then(
        (m) => m.ObjectGroupsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "templates",
    loadChildren: () =>
      import("./templates/templates.module").then((m) => m.TemplatesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "targets",
    loadChildren: () =>
      import("./targets/targets.module").then((m) => m.TargetsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "valueconfigs",
    loadChildren: () =>
      import("./valueconfigs/valueconfigs.module").then(
        (m) => m.ValueConfigsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "valueconfigoptions",
    loadChildren: () =>
      import("./valueconfigoptions/valueconfigoptions.module").then(
        (m) => m.ValueConfigOptionsModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "reports-view",
    loadChildren: () =>
      import("./reports-view/reports-view.module").then(
        (m) => m.ReportsViewModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "invoicing",
    loadChildren: () =>
      import("./invoicing/invoicing.module").then((m) => m.InvoicingModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "dashboard/v3/view",
    loadChildren: () =>
      import("./dashboard-embed/dashboard-embed.module").then(
        (m) => m.DashboardEmbedModule,
      ),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboards/dashboards.module").then((m) => m.DashboardsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "module",
    loadChildren: () =>
      import("./modules/modules.module").then((m) => m.ModulesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "processes",
    loadChildren: () =>
      import("./processes/processes.module").then((m) => m.ProcessesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "report-widget",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "reportbundles",
    loadChildren: () =>
      import("./reportbundles/reportbundles.module").then(
        (m) => m.ReportBundlesModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "workflow-designer",
    loadChildren: () =>
      import("./workflow-designer/workflow-designer.module").then(
        (m) => m.WorkflowDesignerModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "guards/guard-request",
    loadChildren: () =>
      import("./guards/guard-request/guard-request.module").then(
        (m) => m.GuardRequestModule,
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "supplier-portal",
    loadChildren: () =>
      import("./supplier-portal/supplier-portal.module").then(
        (m) => m.SupplierPortalModule,
      ),
    canMatch: [SupplierPortalV2GuardService],
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "**", redirectTo: "/login" },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
